import { TAXONOMY_SCHEMA_AGENT_ID } from '@inference.engine/taxonomy/web';
import { usePageAgentPanel } from '@/entities/agent';
import { useOpenedFile, useSchemaAgentChat } from '@/features/taxonomy-agents';

/**
 * The agent a schema's page hosts, for someone who can manage schemas. A page opened to build the
 * schema from a file opens the panel and hands the agent that file.
 */
export function useSchemaAgentHost(taxonomyId: string, canManage: boolean) {
  const opened = useOpenedFile(taxonomyId);
  const panel = usePageAgentPanel(TAXONOMY_SCHEMA_AGENT_ID, Boolean(opened));
  const chat = useSchemaAgentChat(taxonomyId, opened);
  return { panel, chat: canManage ? chat : null };
}
